import React from "react";
import { Button } from "@mantine/core";
import { IconArrowMoveLeft, IconArrowMoveRight } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import styles from "./TransactionDetailsPage.module.scss";
export default function TransactionNavigatorButton({ type, link }: { type: "next" | "prev", link: string; }) {
  const isNext = type === "next";
  return (
    <>
      <Button
        style={{ background: isNext ? "var(--light-gray-gradient-reverse)" : "var(--light-gray-gradient)" }}
        className={styles.transactionNavigatorButton}
        component={Link}
        to={link}
        leftSection={!isNext ? <IconArrowMoveLeft size={"20"} /> : undefined}
        rightSection={isNext ? <IconArrowMoveRight size={"20"} /> : undefined}
      >
        {isNext ? "Next transaction" : "Previous transaction"}
      </Button>
    </>
  );
}
